import { ca } from '@cian/analytics';

import { TSellerType } from '../NewbuildingCallButton/tracking';

export interface ITrackAddFavoriteGallery {
  newbuildingId: number;
  url?: string;
  sellerType: TSellerType;
}

export function trackAddFavoriteGallery({ newbuildingId, url, sellerType }: ITrackAddFavoriteGallery) {
  ca('eventSite', {
    name: 'oldevent',
    category: 'favorite',
    action: 'add_from_compare_jk',
    label: url,
    products: [{ id: newbuildingId, offerType: 'JK' }],
    page: {
      extra: {
        seller_type: sellerType,
        source: 'gallery',
      },
    },
  });
}
